import { Input } from "@clintonelec/react-storybook";
import {
	invalidHttpPortValueMessage, invalidHttpsPortValueMessage, invalidRtspPortValueMessage
} from "Data/Objects/Network";
import { validateHttpPort, validateHttpsPort, validateRtspPort } from "Data/Utils/Port";
import type { NetworkIpSettings } from "Interfaces";
import { Fragment, memo } from "react";

type PortsSetupSettingsProps = {
	ipSetupSettings: NetworkIpSettings;
	updateHttpPort: (httpPort: string) => void;
	updateHttpsPort: (httpsPort: string) => void;
	updateRtspPort: (rtspPort: string) => void;
};

function PortsSetupSettings(props: PortsSetupSettingsProps) {
	const {
		ipSetupSettings, updateHttpPort: handleHttpPortUpdate, updateHttpsPort: handleHttpsPortUpdate,
		updateRtspPort: handleRtspPortUpdate
	} = props;

	const { httpPort, rtspPort, httpsPort } = ipSetupSettings.servicePortSettings;

	return (
		<Fragment>
			<div className="form-row">
				<label>HTTP Port</label>
				<Input
					hideCharMessage
					name="httpPort"
					onUpdate={ handleHttpPortUpdate }
					type="number"
					value={ httpPort }
					validator={ validateHttpPort }
					validityMessage={ invalidHttpPortValueMessage }
					wrapClassName="form-input"
				/>
			</div>
			<div className="form-row">
				<label>HTTPS Port</label>
				<Input
					hideCharMessage
					name="httpsPort"
					onUpdate={ handleHttpsPortUpdate }
					type="number"
					value={ httpsPort }
					validator={ validateHttpsPort }
					validityMessage={ invalidHttpsPortValueMessage }
					wrapClassName="form-input"
				/>
			</div>
			<div className="form-row">
				<label>RTSP Port</label>
				<Input
					hideCharMessage
					name="rtspPort"
					onUpdate={ handleRtspPortUpdate }
					type="number"
					value={ rtspPort }
					validator={ validateRtspPort }
					validityMessage={ invalidRtspPortValueMessage }
					wrapClassName="form-input"
				/>
			</div>
		</Fragment>
	);
}

export default memo(PortsSetupSettings);
